angular.module('setViewTemplateModule', [])
.service('setViewTemplateService', ['localizationService', function(localizationService) {

this.viewTemplates = [
  {
      title: 'One Column Layout', 
      icon: 'view_template_one',
      template: [{
        'allowed_types': ['gh_float'],
        'template_id': 'gh_flex',
        'name': '',
        'icon_id': '',
        'class': 'gh_flex gh_col_height_1 gh_height_px',
        'container_id': 0,
        'priority': 0,
        'content': [{
          'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
          'template_id': 'gh_float',
          'name': '',
          'icon_id': '',
          'class': 'gh_float gh_col_width_12 gh_col_height_0 gh_height_percent gh_width_percent',
          'container_id': 0,
          'priority': 0,
          'content': []
        }]
      },{
        'allowed_types': ['gh_float'],
        'template_id': 'gh_flex',
        'name': '',
        'icon_id': '',
        'class': 'gh_flex gh_col_height_0 gh_height_percent vertical_scroll',
        'container_id': 0,
        'priority': 0,
        'content': [{
          'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
          'template_id': 'gh_float',
          'name': '',
          'icon_id': '',
          'class': 'gh_float gh_col_width_12 gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll',
          'container_id': 0,
          'priority': 0,
          'content': [{
              "allowed_types": ["gh_float", "gh_element", "gh_tabs", "gh_dropdown"],
              "template_id": "gh_float", 
              "name": "",
              "icon_id": "", 
              "class": "gh_float gh_col_width_12 gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll",
              "container_id": 0,
              "priority": 0,
              "content": []
           }]
        }]
      }]
  },
  {
      title: 'Two Column Layout',
      icon: 'view_template_two',
      template: [{
        'allowed_types': ['gh_float'],
        'template_id': 'gh_flex',
        'name': '',
        'icon_id': '',
        'class': 'gh_flex gh_col_height_1 gh_height_px',
        'container_id': 0,
        'priority': 0,
        'content': [{
          'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
          'template_id': 'gh_float',
          'name': '',
          'icon_id': '',
          'class': 'gh_float gh_col_width_12 gh_col_height_0 gh_height_percent gh_width_percent',
          'container_id': 0,
          'priority': 0,
          'content': []
        }]
      },{
        'allowed_types': ['gh_float'],
        'template_id': 'gh_flex',
        'name': '',
        'icon_id': '',
        'class': 'gh_flex gh_col_height_0 gh_height_percent vertical_scroll',
        'container_id': 0,
        'priority': 0,
        'content': [{
          "allowed_types": ["gh_float", "gh_element", "gh_tabs", "gh_dropdown"],
          "template_id": "gh_float", 
          "name": "",
          "icon_id": "", 
          "class": "gh_float gh_col_width_12 gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll",
          "container_id": 0,
          "priority": 0,
          "content": [{
            'allowed_types': ['gh_flex', 'gh_element', 'gh_tabs'],
            'template_id': 'gh_float',
            'name': '',
            'icon_id': '',
            'class': 'gh_float gh_col_width_6 gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll',
            'container_id': 0,
            'priority': 0,
            'content': []
          },
          {
            'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
            'template_id': 'gh_float',
            'name': '',
            'icon_id': '',
            'class': 'gh_float gh_col_width_6 gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll',
            'container_id': 0,
            'priority': 0,
            'content': []
          }]
        }]
      }]
  },
  {
      title: 'Three Column Layout',
      icon: 'view_template_three',
      template: [{
        'allowed_types': ['gh_float'],
        'template_id': 'gh_flex',
        'name': '',
        'icon_id': '',
        'class': 'gh_flex gh_col_height_1 gh_height_px',
        'container_id': 0,
        'priority': 0,
        'content': [{
          'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
          'template_id': 'gh_float',
          'name': '',
          'icon_id': '',
          'class': 'gh_float gh_col_width_12 gh_col_height_0 gh_height_percent gh_width_percent',
          'container_id': 0,
          'priority': 0,
          'content': []
        }]
      },{
        'allowed_types': ['gh_float'],
        'template_id': 'gh_flex',
        'name': '',
        'icon_id': '',
        'class': 'gh_flex gh_col_height_0 gh_height_percent vertical_scroll',
        'container_id': 0,
        'priority': 0,
        'content': [{
          "allowed_types": ["gh_float", "gh_element", "gh_tabs", "gh_dropdown"],
          "template_id": "gh_float", 
          "name": "",
          "icon_id": "", 
          "class": "gh_float gh_col_width_12 gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll",
          "container_id": 0,
          "priority": 0,
          "content": [{
            'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
            'template_id': 'gh_float',
            'name': '',
            'icon_id': '',
            'class': 'gh_float gh_col_width_4 gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll',
            'container_id': 0,
            'priority': 0,
            'content': []
          },
          {
            'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
            'template_id': 'gh_float',
            'name': '',
            'icon_id': '',
            'class': 'gh_float gh_col_width_4 gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll',
            'container_id': 0,
            'priority': 0,
            'content': []
          },
          {
            'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
            'template_id': 'gh_float',
            'name': '',
            'icon_id': '',
            'class': 'gh_float gh_col_width_4 gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll',
            'container_id': 0,
            'priority': 0,
            'content': []
          }]
        }]
      }]
  },
  {
      title: 'Two Columns with Full Row',
      icon: 'view_template_four',
      template: [{
        'allowed_types': ['gh_float'],
        'template_id': 'gh_flex',
        'name': '',
        'icon_id': '',
        'class': 'gh_flex gh_col_height_1 gh_height_px',
        'container_id': 0,
        'priority': 0,
        'content': [{
          'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
          'template_id': 'gh_float',
          'name': '',
          'icon_id': '',
          'class': 'gh_float gh_col_width_12 gh_col_height_0 gh_height_percent gh_width_percent',
          'container_id': 0,
          'priority': 0,
          'content': []
        }]
      },{
        'allowed_types': ['gh_float'],
        'template_id': 'gh_flex',
        'name': '',
        'icon_id': '',
        'class': 'gh_flex gh_col_height_0 gh_height_percent vertical_scroll',
        'container_id': 0,
        'priority': 0,
        'content': [{
          "allowed_types": ["gh_float", "gh_element", "gh_tabs", "gh_dropdown"],
          "template_id": "gh_float", 
          "name": "",
          "icon_id": "", 
          "class": "gh_float gh_col_width_12 gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll",
          "container_id": 0,
          "priority": 0,
          "content": [{
            'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
            'template_id': 'gh_float',
            'name': '',
            'icon_id': '',
            'class': 'gh_float gh_col_width_6 gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll',
            'container_id': 0,
            'priority': 0,
            'content': []
          },
          {
            'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
            'template_id': 'gh_float',
            'name': '',
            'icon_id': '',
            'class': 'gh_float gh_col_width_6 gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll',
            'container_id': 0,
            'priority': 0,
            'content': []
          },{
              'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
              'template_id': 'gh_float',
              'name': '',
              'icon_id': '',
              'class': 'gh_float gh_col_width_12 gh_col_height_0 gh_height_percent gh_width_percent',
              'container_id': 0,
              'priority': 0,
              'content': [] 
          }]
        }]
      }]
  },
  {
      title: 'Four Column Layout',
      icon: 'view_template_five',
      template: [{
        'allowed_types': ['gh_float'],
        'template_id': 'gh_flex',
        'name': '',
        'icon_id': '',
        'class': 'gh_flex gh_col_height_1 gh_height_px',
        'container_id': 0,
        'priority': 0,
        'content': [{
          'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
          'template_id': 'gh_float',
          'name': '',
          'icon_id': '',
          'class': 'gh_float gh_col_width_12 gh_col_height_0 gh_height_percent gh_width_percent',
          'container_id': 0,
          'priority': 0,
          'content': []
        }]
      },{
        'allowed_types': ['gh_float'],
        'template_id': 'gh_flex',
        'name': '',
        'icon_id': '',
        'class': 'gh_flex gh_col_height_0 gh_height_percent vertical_scroll',
        'container_id': 0,
        'priority': 0,
        'content': [{
          "allowed_types": ["gh_float", "gh_element", "gh_tabs", "gh_dropdown"],
          "template_id": "gh_float", 
          "name": "",
          "icon_id": "", 
          "class": "gh_float gh_col_width_12 gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll",
          "container_id": 0,
          "priority": 0,
          "content": [{
            'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
            'template_id': 'gh_float',
            'name': '',
            'icon_id': '',
            'class': 'gh_float gh_col_width_6 gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll',
            'container_id': 0,
            'priority': 0,
            'content': []
          },
          {
            'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
            'template_id': 'gh_float',
            'name': '',
            'icon_id': '',
            'class': 'gh_float gh_col_width_6 gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll',
            'container_id': 0,
            'priority': 0,
            'content': []
          },{
            'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
            'template_id': 'gh_float',
            'name': '',
            'icon_id': '',
            'class': 'gh_float gh_col_width_6 gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll',
            'container_id': 0,
            'priority': 0,
            'content': []
          },{
            'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
            'template_id': 'gh_float',
            'name': '',
            'icon_id': '',
            'class': 'gh_float gh_col_width_6 gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll',
            'container_id': 0,
            'priority': 0,
            'content': []
          }]
        }]
      }]
  },
  {
      title: 'Two Row Layout',
      icon: 'view_template_six',
      template: [{
        'allowed_types': ['gh_float'],
        'template_id': 'gh_flex',
        'name': '',
        'icon_id': '',
        'class': 'gh_flex gh_col_height_1 gh_height_px',
        'container_id': 0,
        'priority': 0,
        'content': [{
          'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
          'template_id': 'gh_float',
          'name': '',
          'icon_id': '',
          'class': 'gh_float gh_col_width_12 gh_col_height_0 gh_height_percent gh_width_percent',
          'container_id': 0,
          'priority': 0,
          'content': []
        }]
      },{
        'allowed_types': ['gh_float'],
        'template_id': 'gh_flex',
        'name': '',
        'icon_id': '',
        'class': 'gh_flex gh_col_height_0 gh_height_percent vertical_scroll',
        'container_id': 0,
        'priority': 0,
        'content': [{
          "allowed_types": ["gh_float", "gh_element", "gh_tabs", "gh_dropdown"],
          "template_id": "gh_float", 
          "name": "",
          "icon_id": "", 
          "class": "gh_float gh_col_width_12 gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll",
          "container_id": 0,
          "priority": 0,
          "content": [{
            'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
            'template_id': 'gh_float',
            'name': '',
            'icon_id': '',
            'class': 'gh_float gh_col_width_12 gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll',
            'container_id': 0,
            'priority': 0,
            'content': []
          },{
            'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
            'template_id': 'gh_float',
            'name': '',
            'icon_id': '',
            'class': 'gh_float gh_col_width_12 gh_col_height_0 gh_height_percent gh_width_percent',
            'container_id': 0,
            'priority': 0,
            'content': []
          }]
        }]
      }]
  },
  {
      title: 'Three and Two Column Layout',
      icon: 'view_template_seven',
      template: [{
        'allowed_types': ['gh_float'],
        'template_id': 'gh_flex',
        'name': '',
        'icon_id': '',
        'class': 'gh_flex gh_col_height_1 gh_height_px',
        'container_id': 0,
        'priority': 0,
        'content': [{
          'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
          'template_id': 'gh_float',
          'name': '',
          'icon_id': '',
          'class': 'gh_float gh_col_width_12 gh_col_height_0 gh_height_percent gh_width_percent',
          'container_id': 0,
          'priority': 0,
          'content': []
        }]
      },{
        'allowed_types': ['gh_float'],
        'template_id': 'gh_flex',
        'name': '',
        'icon_id': '',
        'class': 'gh_flex gh_col_height_0 gh_height_percent vertical_scroll',
        'container_id': 0,
        'priority': 0,
        'content': [{
          "allowed_types": ["gh_float", "gh_element", "gh_tabs", "gh_dropdown"],
          "template_id": "gh_float", 
          "name": "",
          "icon_id": "", 
          "class": "gh_float gh_col_width_12 gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll",
          "container_id": 0,
          "priority": 0,
          "content": [{
            'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
            'template_id': 'gh_float',
            'name': '',
            'icon_id': '',
            'class': 'gh_float gh_col_width_4 gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll',
            'container_id': 0,
            'priority': 0,
            'content': []
          },
          {
            'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
            'template_id': 'gh_float',
            'name': '',
            'icon_id': '',
            'class': 'gh_float gh_col_width_4 gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll',
            'container_id': 0,
            'priority': 0,
            'content': []
          },
          {
            'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
            'template_id': 'gh_float',
            'name': '',
            'icon_id': '',
            'class': 'gh_float gh_col_width_4 gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll',
            'container_id': 0,
            'priority': 0,
            'content': []
          },{
            'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
            'template_id': 'gh_float',
            'name': '',
            'icon_id': '',
            'class': 'gh_float gh_col_width_6 gh_col_height_0 gh_height_percent gh_width_percent',
            'container_id': 0,
            'priority': 0,
            'content': []
          },
          {
            'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
            'template_id': 'gh_float',
            'name': '',
            'icon_id': '',
            'class': 'gh_float gh_col_width_6 gh_col_height_0 gh_height_percent gh_width_percent',
            'container_id': 0,
            'priority': 0,
            'content': []
          }]
        }]
      }]
  },
  {
      title: 'Blank Page Layout',
      icon: 'view_template_eight',
      template: [{
        'allowed_types': ['gh_float'],
        'template_id': 'gh_flex',
        'name': '',
        'icon_id': '',
        'class': 'gh_flex gh_col_height_0 gh_height_percent vertical_scroll',
        'container_id': 0,
        'priority': 0,
        'content': [{
          'allowed_types': ['gh_float', 'gh_element', 'gh_tabs'],
          'template_id': 'gh_float',
          'name': '',
          'icon_id': '',
          'class': 'gh_float gh_col_width_12 gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll',
          'container_id': 0,
          'priority': 0,
          'content': []
        }]
      }]
  }
]

this.getDictionary = () => {
  return localizationService.getDictionary('set_view_template');
}

this.initList = (list) => {
  this.list = list;
}

this.setViewTemplate = () => {

  this.viewTemplates[this.currentTemplate].template.forEach( template => {
    this.list.content.push(template);
  })
  
}


this.translate = (word) => {
  return localizationService.translate(word, this.getDictionary());
}

this.getViewTemplates = () => {
  return this.viewTemplates.map(t => Object.assign({}, t, { title: this.translate(t.title) }));
}

this.setCurrentViewTemplate = (index) => {
  this.currentTemplate = index;
}

this.getCurrentViewTemplate = () => {
  return this.viewTemplates[this.currentTemplate];
}

}]);